import { createSafeHtml } from '../../utils/safeHtml';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * 🔄 KONTAKT - DYNAMISCH AUS DB
 * 
 * Diese Seite lädt den Inhalt aus der MongoDB (legal_texts Collection).
 * Bearbeitung erfolgt über das Admin-Panel.
 * 
 * Single Source of Truth: Datenbank
 */

export default function Kontakt() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [content, setContent] = useState({ title: '', content: '' });
  
  useEffect(() => {
    loadContent();
  }, []);
  
  const loadContent = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/legal-texts/kontakt`);
      
      if (!response.ok) {
        throw new Error('Fehler beim Laden');
      }
      
      const data = await response.json();
      setContent({ title: data.title, content: data.content });
      setLoading(false);
    } catch (err) {
      console.error('Error loading kontakt:', err);
      setError('Fehler beim Laden der Kontaktseite');
      setLoading(false);
    }
  };
  
  if (loading) {
    return (
      <div className="min-h-screen bg-black grain-texture flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#10B981]/30 border-t-[#10B981]"></div>
      </div>
    );
  }
  
  if (error) {
    return (
      <div className="min-h-screen bg-black grain-texture text-white flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-500 mb-4">{error}</p>
          <button
            onClick={() => navigate('/welcome')}
            className="px-4 py-2 bg-[#10B981] text-black rounded-lg hover:bg-[#059669]"
          >
            Zurück
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black grain-texture text-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <button
          onClick={() => navigate('/welcome')}
          className="flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
        >
          <ArrowLeft className="w-5 h-5" />
          Zurück
        </button>

        <div className="space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{content.title}</h1>
          
          <div 
            className="p-6 border-2 border-white/10 rounded-xl bg-white/5 space-y-6 prose prose-invert max-w-none legal-content"
            dangerouslySetInnerHTML={createSafeHtml(content.content)}
          />
        </div>
      </div>
    </div>
  );
}
